"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HotelBar;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function HotelBar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "hotel-bar"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M81.835,8.005a2.5,2.5,0,0,0-3.5.489L65.388,25.649H19.671a2.5,2.5,0,0,0-2,4.006l28.87,38.258V87.5H33.761a2.5,2.5,0,0,0,0,5H64.328a2.5,2.5,0,0,0,0-5H51.545V67.913L80.414,29.655a2.5,2.5,0,0,0-2-4.006H71.652L82.325,11.506A2.5,2.5,0,0,0,81.835,8.005ZM61.615,30.649l-5.057,6.7H29.747l-5.058-6.7ZM49.45,50.921a2.5,2.5,0,0,0,3.5-.489l6.1-8.08h5.521L49.045,62.925,33.52,42.352H52.785L48.96,47.42A2.5,2.5,0,0,0,49.45,50.921ZM73.4,30.649l-5.057,6.7H62.822l5.057-6.7Z"
  }))));
}